// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2Cdly4l_e4Z1Az590PbM4T","warningIcon":"_2nT4_8j_kiU4lBDwdRy-2H"};